import { React, useState, useEffect, useRef } from "react";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import MiscDownloadOnAppStore from "../misc_components/MiscDownloadOnAppStore";
import ResizePDFImageListScreen from "./ResizePDFImageListScreen";
import { BASE_URL } from "../Config";
import MiscFAQ from "../misc_components/MiscFAQ";
import MiscRecommendedPages from "../misc_components/MiscRecommendedPages";

function ResizePDFMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || { title: "Resize PDF files" };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);

  //reference loading bar
  const loadingBarRef = useRef(null);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/resize_pdf", title: "Change PDF Dimensions" },
    data2: { link: "/resize_pdf", title: "PDF Resizer" },
    data3: { link: "/resize_pdf", title: "Change PDF Resolution" },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar ref={loadingBarRef} />

      {/*Add title and metadata */}
      <title>{title + " Offline"}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Resize PDF pages online easily. Change page size, scale PDFs, and adjust dimensions quickly with our fast, secure PDF resize tool."
      ></meta>
      <meta
        name="keywords"
        content="resize pdf, resize pdf online, change pdf size, pdf page resize, pdf resizer tool, adjust pdf size, scale pdf pages, pdf page size changer, resize pdf pages online, pdf editor online, pdf management tool, resize pdf for print, resize pdf for upload, pdf layout editor, pdf page scaler, compress pdf, scale pdf pages, pdf compressor, resuce pdf size,"
      ></meta>

      {/* page content */}
      {showEditFileScreen ? (
        <ResizePDFImageListScreen title={title}></ResizePDFImageListScreen>
      ) : (
        <div>
          {/* Nav Bar */}
          <NavBar />
          {/* Title */}
          <MiscPageTitle title={title} online={false} />
          {/* Upload PDF View */}
          <MiscUploadPDFView
            selectMultiple={false}
            filetype={{ "application/pdf": [".pdf"] }}
          />
          {/* Mid Section */}
          <MiscPageMidSection description="Our PDF resizer website offers a fast, secure, and reliable way to resize PDF files offline while also supporting resize PDF online functionality when internet access is available. Designed for users who value privacy and performance, this powerful PDF resizer allows you to adjust PDF file size, page dimensions, and layout directly on your device, ensuring complete data security. Whether you need to resize PDFs for online forms, reduce PDF file size for email sharing, or optimize documents for printing, our tool delivers accurate results without compromising quality. Unlike traditional tools that rely only on cloud processing, this platform works offline, making it ideal for professionals, students, and businesses in low-connectivity environments. Using advanced resizing technology, you can easily scale pages, adjust margins, and resize PDF dimensions while maintaining text clarity and image resolution. No unnecessary file uploads are required—your documents remain private and secure at all times. Compatible with desktop and mobile devices, this PDF resizer website helps you resize PDF online or offline, save storage space, and meet strict size and dimension requirements efficiently. If you’re searching for the best PDF resizer offline, resize PDF online, resize PDF without internet, or a secure PDF resizing tool, our platform provides a seamless, user-friendly solution built for speed, accuracy, and privacy." />
          {/* How to use */}
          <HomeScreenHowToUse
            steps={{
              step1: "Select",
              step2: "Offline",
              step3: "Resize",
              step4: "Download",
            }}
          />
          {/* Why use section */}
          <MiscWhyUse
            title="Resize PDF"
            why_use={[
              {
                title: "Meet File Size and Dimension Requirements",
                description:
                  "Many online portals, job applications, government forms, and academic websites have strict limits on PDF file size and page dimensions. Using a compress and resize PDF tool helps you reduce PDF size and adjust page dimensions to meet upload requirements easily.",
              },
              {
                title: "Faster Upload and Download Speed",
                description:
                  "Large PDF files take longer to upload and download. When you compress PDF files and resize PDFs, it significantly improves file transfer speed and ensures a smooth user experience.",
              },
              {
                title: "Easy Sharing via Email and Messaging Apps",
                description:
                  "Email services and messaging platforms often restrict attachment sizes. By using a PDF compressor and resizer, you can share documents quickly without attachment errors or failed uploads.",
              },

              {
                title: "Optimize PDFs for Online Forms",
                description:
                  "Many online forms require PDFs to be under specific size limits such as 200KB. A compress resize PDF online tool helps you optimize documents for fast and successful form submissions.",
              },
              {
                title: "Save Device Storage Space",
                description:
                  "Compressed and resized PDFs occupy less storage on your device. A reliable PDF size reducer helps keep your storage organized and prevents unnecessary memory usage.",
              },
              {
                title: "Improve Website Performance and SEO",
                description:
                  "Smaller PDF files load faster on websites, improving page speed and user engagement. Using compressed and resized PDFs enhances website performance and supports better SEO rankings.",
              },
              {
                title: "Maintain Document Quality",
                description:
                  "Advanced PDF compression and resizing tools preserve text clarity, formatting, and image quality while reducing file size, ensuring professional-looking documents.",
              },
              {
                title: "Better Compatibility Across Devices",
                description:
                  "Different platforms and devices require optimized file sizes and layouts. When you resize PDF pages and compress PDF online, documents display correctly on mobile, tablet, and desktop screens.",
              },
              {
                title: "Enhance Privacy and Security",
                description:
                  "Many modern tools allow you to compress and resize PDF offline or securely online, ensuring sensitive documents remain private and protected during processing.",
              },
            ]}
          />
          {/* FAQ */}
          <MiscFAQ
            faq_list={[
              {
                title: "What is a PDF resizer?",
                description:
                  "A PDF resizer is a tool that changes the page dimensions of a PDF document. It can help you adjust pages to standard sizes such as A4, A3, Letter, or Legal, depending on the tool's available options.",
              },
              {
                title: "How can I resize a PDF for free?",
                description:
                  "Open the PDF resizer on ShivaPDF.com, select your PDF, choose the desired page size or resizing options, and process the document. Download the resized PDF when processing is complete.",
              },
              {
                title: "Can I resize a PDF offline?",
                description:
                  "Yes, if the PDF resizer supports local processing, you can resize PDF pages without an internet connection after the tool and its required resources have loaded. Offline functionality depends on the implementation.",
              },
              {
                title: "Does ShivaPDF upload my PDF when resizing it?",
                description:
                  "A locally processed PDF resizer can change page dimensions directly in your browser without sending the document to a server. Check the tool's implementation and privacy policy to confirm how your files are handled.",
              },
              {
                title: "How do I change the page size of a PDF?",
                description:
                  "Select your PDF in the resizing tool, choose a supported page size or custom dimensions, and apply the changes. Save the resulting document and check that its pages fit your intended use.",
              },
              {
                title: "Can I resize a PDF to A4 size?",
                description:
                  "Yes, if A4 is available in the tool's page-size options. A4 is a common paper size measuring 210 × 297 mm and is frequently used for reports, letters, forms, and office documents.",
              },
              {
                title: "Can I resize a PDF to A3 size?",
                description:
                  "You can resize a PDF to A3 if the tool supports that page size. A3 measures 297 × 420 mm and is useful for larger documents, diagrams, posters, and drawings.",
              },
              {
                title: "Can I resize a PDF to Letter or Legal size?",
                description:
                  "If supported by the tool, you can change PDF pages to US Letter or Legal dimensions. Letter measures 8.5 × 11 inches, while Legal measures 8.5 × 14 inches.",
              },
              {
                title: "Can I set custom PDF page dimensions?",
                description:
                  "Custom page dimensions are available only if the PDF resizer supports them. If available, enter the required width and height, select the appropriate units, and review the result after processing.",
              },
              {
                title: "Does resizing a PDF reduce its file size?",
                description:
                  "Changing PDF page dimensions does not necessarily reduce the file size. To make a PDF smaller in megabytes or kilobytes, use a PDF compression tool that reduces image or document data.",
              },
              {
                title: "Will resizing a PDF reduce image quality?",
                description:
                  "Changing page dimensions alone does not always reduce image quality, but scaling content or applying compression can affect its appearance. Review text, images, and graphics in the output PDF before using it.",
              },
              {
                title: "Can I resize a PDF without changing its content?",
                description:
                  "A PDF resizer can change the page dimensions while retaining the existing text and images. Depending on the resizing method, content may be scaled, repositioned, or surrounded by additional white space.",
              },
              {
                title: "Can I resize only one page of a PDF?",
                description:
                  "This depends on whether the tool supports selecting individual pages. If it does, choose the page you want to resize and apply the required dimensions; otherwise, the same settings may be applied to the entire document.",
              },
              {
                title: "Can I resize all pages of a PDF at once?",
                description:
                  "Yes, if the tool supports resizing an entire document, you can apply the selected page dimensions to all pages in one operation. Review the output to confirm that the page sizes are consistent.",
              },
              {
                title: "Can I resize a PDF from portrait to landscape?",
                description:
                  "Changing a PDF from portrait to landscape may be possible by selecting landscape orientation or changing its page dimensions. Depending on the tool, you may also need a separate rotate-PDF option to change page orientation.",
              },
              {
                title: "Can I resize a scanned PDF?",
                description:
                  "Yes, a scanned PDF can generally have its page dimensions changed without needing to recognize the text. However, the scan may be scaled or repositioned depending on the resizing method.",
              },
              {
                title: "Can I resize a PDF on my phone?",
                description:
                  "You can resize PDFs on a compatible iPhone or Android device using a mobile-friendly browser-based tool. Open ShivaPDF.com, select your document, and use the available resizing options.",
              },
              {
                title: "Can I resize a PDF on Windows or Mac?",
                description:
                  "A browser-based PDF resizer can work on compatible Windows and Mac computers. Open ShivaPDF.com in a supported browser, choose your PDF, and adjust its page dimensions using the available controls.",
              },
              {
                title: "Can I resize a PDF without installing software?",
                description:
                  "A browser-based PDF resizer lets you change page dimensions without installing a separate desktop application. The available options depend on the tool's supported features and your browser.",
              },
              {
                title: "Is ShivaPDF's PDF resizer free?",
                description:
                  "ShivaPDF provides browser-based PDF tools for common document tasks. Check the PDF resizer page for current availability, supported page sizes, file-size limits, and any usage restrictions.",
              },
              {
                title: "Can I resize a PDF without creating an account?",
                description:
                  "You may be able to resize PDF files without registering if the tool does not require an account. Check the current ShivaPDF page for access requirements and any applicable limits.",
              },
              {
                title: "Why does my resized PDF have white borders?",
                description:
                  "White borders can appear when the original content does not fill the selected page dimensions or when the resizing method preserves the entire page. Check the page-size settings and content scaling options.",
              },
              {
                title: "Why is my PDF content cut off after resizing?",
                description:
                  "Content may be cut off if the new page dimensions are too small or the resizing method does not scale the original content appropriately. Try a larger page size or a scaling option that fits the content within the page.",
              },
              {
                title: "How do I save a resized PDF?",
                description:
                  "After selecting the desired dimensions and processing the document, use the tool's download or save option. Open the downloaded PDF to verify its page dimensions, layout, and content.",
              },
            ]} />
          {/* Download on Appsroe */}
          <MiscDownloadOnAppStore
            id={`https://apps.apple.com/app/id${1609168763}`}
          />
          {/* Looking for section */}
          <MiscPageLookingFor data={lookingForObject} />
          {/* Recommended Tools */}
          <MiscRecommendedPages />
          {/* Footer */}
          <Footer />
        </div>
      )}
    </PageContext.Provider>
  );
}

export default ResizePDFMain;
